import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { AdminHospitalRepository } from './domain'

import { AdminHospitalInfo } from '../../contracts/hospital'
import { AxiosErrorHandler, SolarPagedResponse } from '../../foundation'

export class AdminApiHospital implements AdminHospitalRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getHospitalNames = async (
    countries: string[] = [],
  ): Promise<{
    names: { id: number; name: string }[]
  }> => {
    const data = {
      filter: {
        countries,
      },
    }
    const config: AxiosRequestConfig = {
      url: '/hospital/admin/queries/hospitals-name/process',
      method: 'post',
      data,
    }

    try {
      const { data } = await this.axios.request<{ names: { id: number; name: string }[] }>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  getHospitalsByIds = async (ids: number[]): Promise<AdminHospitalInfo[]> => {
    const config: AxiosRequestConfig = {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      url: `/admin/v2/hospitals?start=0&length=${ids.length}&ids=${ids}`,
      method: 'get',
    }

    try {
      const { data } = await this.axios.request<SolarPagedResponse<AdminHospitalInfo[]>>(config)
      return data.data ?? []
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
